import React, {useState, useRef} from 'react';
import picPortrait from '../assets/img/pic_portrait.jpg';

import { Container, Row, Col, Collapse, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFutbol, faUserCircle, faAngleDown} from '@fortawesome/free-solid-svg-icons';

import { RoundButtonSecondary } from "./buttons";

import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/App.css';


const MoreInfo = () => {
    const [isOpen, setIsOpen] = useState(false);    
    const moreInfoRef = useRef();

    return (
        <Container className="mt-4 mx-3" style={{backgroundColor: "#fff", borderRadius: "0.5em"}}>
            <div ref={moreInfoRef} id="sticazzi">
                <div style={{display: "inline-block", width: "10%"}}>
                    &shy;
                </div>
                <div style={{display: "inline-block", width: "80%"}}>
                    <h3 className="py-3 text-primary d-md-block d-none" style={{fontSize: "1.3em"}}>Vuoi saperne di più su di me?</h3>
                    <h3 className="py-3 text-primary d-block d-md-none" style={{fontSize: "1.3em"}}>Vuoi saperne di più?</h3>
                </div>
                <div style={{display: "inline-block", width: "10%"}}>
                    <Button onClick={() => setIsOpen(!isOpen)} className="button-arrow">
                        <FontAwesomeIcon icon={faAngleDown} size='4x' className='px-1' style={{color: "var(--logo_1)"}} />
                    </Button>
                </div>
            </div>
            <Collapse 
                isOpen={isOpen} 
                onEntered={() => {
                    if (isOpen) {
                        window.scroll({
                            top: moreInfoRef.current.offsetTop - window.document.querySelector("#mainNav").offsetHeight - 5, 
                            left: 0,
                            behavior: "smooth"
                        });
                    }
                }}>
                <Container className="p-4">
                    <Row>
                        <Col lg="6">
                            <div>
                                <h3 className="my-5 text-primary" style={{fontSize: "1.3em"}}>Le mie specializzazioni</h3>
                            </div>
                            <div className="service-box mt-2 mb-5 mx-auto">
                                <FontAwesomeIcon icon={faFutbol} size='4x' className='mb-3' style={{color: "var(--logo_1)"}} />
                                <h3 className="mb-3 text-primary">Fisioterapia sportiva</h3>
                                <p className="my-4 text-spec-claim">
                                Dolore ad un tendine che non si risolve? Fitta ad un muscolo? Distorsione di caviglia?
                                </p>
                                <p className="text-muted mb-0">
                                Aiuto soggetti sportivi che hanno subito un trauma, o che soffrono di un dolore cronico, 
                                ad inquadrare il problema ed impostare il recupero...<br />
                                nel più breve tempo possibile!
                                </p>
                            </div>
                            <div className="service-box mt-5 mx-auto">
                                <FontAwesomeIcon icon={faUserCircle} size='4x' className='mb-3' style={{color: "var(--logo_1)"}} />
                                <h3 className="mb-3 text-primary">Disturbi della colonna</h3>
                                <p className="my-4 text-spec-claim">
                                Lo sapevi che i dolori a collo e zona lombare sono i più diffusi tra la popolazione mondiale?
                                </p>
                                <p className="text-muted mb-0">
                                Per affrontarli mi baso sulle più recenti ricerche scientifiche secondo cui un approccio 
                                fisioterapico personalizzato è il miglior modo...<br />
                                per tornare a muoversi senza pensieri!
                                </p>
                            </div>
                        </Col>
                        <Col lg="6">
                            <div>
                                <h3 className="my-5 text-primary" style={{fontSize: "1.3em"}}>La mia esperienza</h3>
                            </div>
                            <div className="mt-2 mx-auto my-auto text-justify">
                                <p className="text-muted">
                                Prima della laurea ho completato gli studi liceali ed ho sempre praticato sport.
                                Questa passione è stata il motore principale nello scegliere il percorso universitario in Fisioterapia,
                                per studiare come aiutare soggetti che praticano sport a recuperare al meglio dopo un infortunio.
                                </p>
                                <p className="text-muted">
                                Durante gli studi e con le prime esperienze lavorative mi sono scontrato con realtà e credenze sul
                                mondo fisioterapico talvolta superate. Questo mi ha spronato nell’aggiornamento continuo in ambito
                                ortopedico/sportivo con formazione scientifica.
                                Ho frequentato un Master di I livello in Riabilitazione dei Disordini Muscolo-Scheletrici
                                e ho seguito vari corsi di aggiornamento per proporre soluzione di trattamento e
                                strategia preventive il più vicine possibili agli standard internazionali.
                                </p>
                                <p className="text-muted">
                                Partecipo attivamente alla crescita scientifica della fisioterapia attraverso le associazioni di 
                                categoria di cui faccio parte, come il Gruppo di interesse specialistico in Terapia Manuale (GTM) 
                                e il Gruppo di interesse specialistico in Fisioterapia Sportiva (GIS Sport). Con quest'ultimo, 
                                di cui nel 2020 ho svolto il ruolo di referente regionale, ho partecipato ad eventi con la nazionale 
                                sudafricana e neozelandese di Rubgy durante i test match in Italia nel 2017 e nel 2018. Nello stesso 
                                anno, ho supportato lo staff sanitario ai mondiali di pattinaggio su ghiaccio a Milano.
                                </p>
                                <p className="text-muted">
                                Sono anche attivo in ambito universitario.
                                Dal 2015 al 2017 ho collaborato alla stesura di tesi di laurea in Fisioterapia in qualità di 
                                correlatore, mentre dal 2018 partecipo come assistente docente al corso elettivo sul tema della 
                                riabilitazione sportiva presso l’università Statale di Milano e dal 2019 presso l’Università
                                di Milano-Bicocca.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Collapse>
        </Container>
    );
}

const About = () => {
    return (
        <section id='about' className='elem-content-container bg-primary'>
            <Container >
                <Row>
                    <Col lg="10" className="mx-auto text-center">
                        <h2 className="section-heading text-white mb-5">
                        Gianmarco Verbana
                        <span className="d-inline d-md-none m-0"><br /></span>
                        <span className="d-none d-md-inline m-0"> - </span>
                        Fisioterapista
                        </h2>
                    </Col>
                </Row>
                <Row>
                    <Col lg='4'>
                        <img src={picPortrait} width="100%" className="mb-4" style={{border: 'solid 3px #fff'}} alt='Gianmarco Verbana portrait' />
                    </Col>
                    <Col lg='8' className="mx-auto my-auto text-justify">
                        <p className="text-white text-about-me mb-4">
                        Mi chiamo Gianmarco Verbana, sono Fisioterapista dal 2011 ed aiuto le persone a comprendere, 
                        gestire e risolvere dolori, disturbi persistenti ed infortuni.
                        </p>
                        <p className="text-white text-center text-about-me mb-4">
                        Come?
                        </p>
                        <p className="text-white text-center text-about-me mb-4" style={{fontSize: "1.6em"}}>
                            <b>PASSIONE</b>
                            <span className="d-inline d-md-none m-0"><br /></span>
                            <span className="d-none d-md-inline m-0">, </span>
                            <b>COMPETENZA</b>
                            <span className="d-inline d-md-none m-0"><br /></span>
                            <span className="d-none d-md-inline m-0"> ed </span>
                            <b>ATTENZIONE ALLA PERSONA</b>
                        </p>
                        <p className="text-white text-about-me mb-2">
                        Dalla presa in carico, il paziente sarà guidato passo dopo passo per raggiungere al meglio ed 
                        il più velocemente possibile il proprio obiettivo, con un percorso di recupero personalizzato.
                        </p>
                        <div className="mx-auto py-5 text-center">
                            <RoundButtonSecondary to='/contacts/' text='Contattami per un consulto!' />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <MoreInfo />
                </Row>
            </Container>
        </section>
    );
};

export default About;
